import { Controller } from "@hotwired/stimulus"

// A document Jane is still writing fills in on screen. While the server says it
// is drafting (the sheet carries data-document-live-active-value), this asks for
// just the sheet every couple of seconds and swaps it in; when the draft ends
// the whole view reloads once, so the header, menu and version list catch up.
//
// It never swaps while someone is using the title menu or renaming, and it
// pauses in a background tab. A document that is not drafting costs nothing:
// the controller does not start a timer.
const INTERVAL_MS = 1500

export default class extends Controller {
    static values = { url: String, active: Boolean, panel: Boolean, panelUrl: String, title: String }

    connect() {
        if (this.activeValue) this._timer = setInterval(() => this._tick(), INTERVAL_MS)
    }

    disconnect() {
        clearInterval(this._timer)
    }

    async _tick() {
        if (document.hidden || this._busy() || this._loading) return

        this._loading = true
        try {
            const response = await fetch(this.urlValue, { headers: { Accept: "text/html" }, credentials: "same-origin" })
            if (!response.ok) return

            const drafting = response.headers.get("X-Document-Drafting") === "true"
            if (!drafting) {
                clearInterval(this._timer)
                return this._finished()
            }
            const html = await response.text()
            if (this.element.innerHTML.trim() !== html.trim()) this.element.innerHTML = html
        } catch (_error) {
            /* a dropped poll is retried on the next tick */
        } finally {
            this._loading = false
        }
    }

    _finished() {
        if (this.panelValue) {
            window.dispatchEvent(new CustomEvent("jane:open-panel", {
                detail: { url: this.panelUrlValue, title: this.titleValue, icon: "bi-file-earmark-word", label: "Document" }
            }))
        } else {
            window.location.reload()
        }
    }

    // Someone is in the title menu or typing a new name: leave the page alone.
    _busy() {
        return !!document.querySelector(".document-menu-panel.is-open, input.document-menu-rename")
    }
}
